import React from 'react';
import BaseLayout from './base.js';
import * as u from '../utils.js';
import Pagination from './pagination.js';
import LoadMoreButton from './loadmore.js';
import Testimonial from '../testimonial.js';
import AppSettingsContext from '../context.js';
import DEFS from '../defs.js'

/*---------------------------------------------*/

class MultipageTableLayout extends BaseLayout {
	constructor(props) {
		super(props);

		this.next = this.next.bind(this);
		this.prev = this.prev.bind(this);

		this.state = {
			page: 0
		}
	}

	componentWillMount() {
		this.initNavigation();
	}

	initNavigation() {
		this.rows = this.props.rows;
		this.columns = this.props.columns;
		
		let rows = this.rows || 1;
		let columns = this.columns || 1;
		let itemsPerPage = columns*rows;
		let pageCount = Math.ceil(this.props.items.length / itemsPerPage);	
		this.navigation = {
			itemsPerPage: itemsPerPage,
			pageCount: pageCount
		};

		this.setState({currentPage: 0});
	}

	next() {
		if (!this.nextAvailable())
			return;

		var p = this.state.currentPage + 1;
		this.setState({currentPage: p});

		this.setState({animation: true})
		setTimeout(() => this.setState({animation: false}));

		window.ga && window.ga('send','event','navigation',(this.props.columns === 1) ? 'list' : 'grid','page-next');
	}

	prev() {
		if (!this.prevAvailable())
			return;
		
		var p = this.state.currentPage - 1;
		this.setState({currentPage: p});

		this.setState({animation: true})
		setTimeout(() => this.setState({animation: false}));

		window.ga && window.ga('send','event','navigation',(this.props.columns === 1) ? 'list' : 'grid','page-prev');
	}

	nextAvailable() {
		return this.state.currentPage < this.navigation.pageCount-1;
	}

	prevAvailable() {
		return this.state.currentPage > 0;
	}

	render() {
		let pageCount = this.navigation.itemsPerPage && Math.ceil(this.props.items.length / this.navigation.itemsPerPage);
		if (this.rows !== this.props.rows || this.columns !== this.props.columns || pageCount !== this.navigation.pageCount)
			this.initNavigation();

		let styles = {
			container: {
				...this.props.baseStyle.container,
				overflow: 'hidden'
			},
			sizer: this.props.baseStyle.sizer,
			testimonial: {
			},
			navigation: {
				textAlign: this.context.get('layout.navigation.position'),
				transform: `translateY(${this.props.baseStyle.container.paddingBottom/2}px)`
			},
			pages: {
				display: 'grid',
				gridTemplateColumns: '1fr'
			},
			page: {
				display: 'grid',
				gridTemplateColumns: `repeat(${this.columns},1fr)`,
				alignContent: 'start',
				gridRowStart: 1,
				gridColumnStart: 1
			},
			invisiblePage: {
				visibility: 'hidden',
				pointerEvents: 'none',
				width: '100%'
			}
		}

		let items = this.props.items;
		let itemsPerPage = this.navigation.itemsPerPage;
		let pages = Array(this.navigation.pageCount).fill(null).map((v,i) => {
			let pageItems = items.slice(itemsPerPage*i, itemsPerPage*(i+1));
			return pageItems.map((item,j) => {
				let index = itemsPerPage*i+j;
				let rowIndex = 1+Math.floor(index/this.columns);
				return <Testimonial data={item} key={index} baseStyle={styles.testimonial} page={i+1} row={rowIndex} alignGroup={100*rowIndex} />
			});
		});

		let content = pages.map((page,i) => {
			let isCurrentPage = (i === this.state.currentPage);
			let style = styles.page;
			if (!isCurrentPage) {
				style = {...style, ...styles.invisiblePage};
			}

			return <div style={style} key={i}>{page}</div>
		});

		return (
			<div className="testimonials grid" ref={this.container} style={styles.container}>
				<div style={styles.sizer}>
					<div style={styles.pages}>
						{content}
					</div>
				</div>
				<div style={styles.navigation}>
					<Pagination 
						prev={this.prevAvailable() ? this.prev : undefined} 
						next={this.nextAvailable() ? this.next : undefined}>
					</Pagination>
				</div>
			</div>
		)
	}
}

/*---------------------------------------------*/

class FeedTableLayout extends BaseLayout {
	constructor(props) {
		super(props);

		this.prevSettings = {};
		this.more = this.more.bind(this);
		this.loadedCount = 0;
	}

	more() {
		let rowsToLoad = this.context.get('layout.navigation.loadmore.rows',1);
		this.loadedCount = this.loadedCount + rowsToLoad;
		this.forceUpdate();
		
		u.dispatchEvent(this.container.current,'content-changed');

		window.ga && window.ga('send','event','navigation',(this.props.columns === 1) ? 'list' : 'grid','load-more');
	}

	componentDidMount() {
		super.componentDidMount();

		window.inffuse.on('view-mode-changed', () => {
			this.loadedCount = 0;
			this.forceUpdate();
		});
	}

	render() {
		let columns = this.props.columns || 1;
		let rows = this.props.rows || 1;

		let styles = {
			container: {
				...this.props.baseStyle.container,
				overflow: 'hidden'
			},
			sizer: this.props.baseStyle.sizer,
			testimonial: {
				width: `${100/columns}%`
			},
			navigation: {
				transform: `translateY(${this.props.baseStyle.container.paddingBottom/2}px)`
			}
		}

		let items = this.props.items;
		let itemsToDisplay = (rows+this.loadedCount)*columns;

		if (this.prevSettings.rowsToLoad !== this.context.get('layout.navigation.loadmore.rows') || this.prevSettings.rows !== this.props.rows)
			this.loadedCount = 0;

		let moreAvailable = itemsToDisplay < items.length;
		if (moreAvailable) {
			this.prevSettings.rows = this.props.rows;
			this.prevSettings.rowsToLoad = this.context.get('layout.navigation.loadmore.rows');
		
		} else {
			styles.navigation.opacity = 0.2;
			styles.navigation.pointerEvents = "none";
		}
		
		items = items.slice(0,itemsToDisplay).map((item,i) => {
			let rowIndex = 1+Math.floor(i/columns);
			return <Testimonial data={item} key={i} baseStyle={styles.testimonial} page={1} row={rowIndex} alignGroup={100*rowIndex} />
		})
		
		let navigation = <LoadMoreButton baseStyle={styles.navigation} onClick={this.more} />
	
		return (
			<div className="testimonials grid" ref={this.container} style={styles.container}>
				<div style={styles.sizer}>{items}</div>
				{navigation}
			</div>
		)
	}
}

/*---------------------------------------------*/

class SimpleTableLayout extends BaseLayout {
	render() {
		let columns = this.props.columns || 1;
		let styles = {
			container: {
				...this.props.baseStyle.container,
				overflow: 'hidden'
			},
			sizer: this.props.baseStyle.sizer,
			testimonial: {
				width: `${100/columns}%`
			}
		}


		let items = this.props.items;
		items = items.map((item,index) => {
			let rowIndex = 1 + Math.floor(index/columns);
			return <Testimonial data={item} key={index} baseStyle={styles.testimonial} page={1} row={rowIndex} alignGroup={100*rowIndex} />
		});

		return (
			<div className="testimonials grid" ref={this.container} style={styles.container}>
				<div style={styles.sizer}>{items}</div>
			</div>
		)
	}
}

/*---------------------------------------------*/

export default class TableLayout extends React.Component {
	static contextType = AppSettingsContext;

	render() {
		let spacing = this.context.get('layout.spacing');
		let paddingLeftRight = this.context.get('layout.padding.leftright',40,24);
		let paddingTopBottom = this.context.get('layout.padding.topbottom',40,24);
		
		let styles = {
			container: {
				paddingLeft: paddingLeftRight,
				paddingRight: paddingLeftRight,
				paddingTop: paddingTopBottom,
				paddingBottom: paddingTopBottom,
			},
			sizer: {
				marginLeft: -1*spacing/2,
				marginRight: -1*spacing/2,
				marginTop: -1*spacing,
				transform: `translateY(${spacing/2}px)`
			}
		}

		let navType = this.context.get('layout.navigation.type','','');
		if (navType) {
			let displayedCount = this.props.rows*this.props.columns;
			if (this.props.items.length <= displayedCount)
				navType = '';
		}

		if (navType === 'loadmore')
			return <FeedTableLayout items={this.props.items} rows={this.props.rows} columns={this.props.columns} template={this.props.template} baseStyle={styles} />;
			
		if (navType === 'pages')
			return <MultipageTableLayout items={this.props.items} rows={this.props.rows} columns={this.props.columns} template={this.props.template} baseStyle={styles} />;

		if (navType === '') {
			let items = this.props.items;
			if (this.context.isMobile()) {
				items = items.slice(0,this.props.rows*this.props.columns);
			}

			return <SimpleTableLayout items={items} columns={this.props.columns} template={this.props.template} baseStyle={styles} />;
		}

		return `[TableLayout] Invalid navigation type (${navType})`;
	}
}

/*---------------------------------------------*/
